const { z } = require('zod');

const userSchema = z.object({
  phone: z.string()
    .regex(/^\+[1-9]\d{1,14}$/, 'Phone must be in E.164 format: +[country code][number] (e.g., +1234567890)'),
  
  name: z.string()
    .min(1, 'Name is required')
    .max(100, 'Name must be at most 100 characters'),
  
  email: z.union([
    z.literal(''),
    z.string().email('Invalid email address')
  ]).optional(),
  
  bio: z.union([
    z.literal(''),
    z.string().max(500, 'Bio must be at most 500 characters')
  ]).optional(),
  
  instagram: z.union([
    z.literal(''),
    z.string().regex(/^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/, 'Invalid Instagram username format')
  ]).optional(),
  
  twitter: z.union([
    z.literal(''),
    z.string().regex(/^@?(\w){1,15}$/, 'Twitter handle must be 1-15 characters, letters/numbers/underscores only')
  ]).optional(),
  
  linkedin: z.union([
    z.literal(''),
    z.string().regex(/^https?:\/\/(www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9_-]+\/?$/, 'Must be a valid LinkedIn profile or company URL')
  ]).optional(),
  
  github: z.union([
    z.literal(''),
    z.string().regex(/^[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}$/i, 'GitHub username: alphanumeric/hyphens, cannot start/end with hyphen, max 39 chars')
  ]).optional(),
  
  website: z.union([
    z.literal(''),
    z.string().url('Must be a valid URL')
  ]).optional(),
  
  location: z.union([
    z.literal(''),
    z.string().max(100, 'Location must be at most 100 characters')
  ]).optional(),
  
  interests: z.array(z.string().max(50))
    .max(10, 'Maximum 10 interests allowed')
    .optional()
});

module.exports = { userSchema };
